<template>
   <div class="pasta-card card" @click="abrirPasta">
      <div class="pasta-icon">
         <i class="fas fa-folder-open"></i>
      </div>
      <div class="pasta-content">
         <h5 class="pasta-nome">{{ pasta.nome || 'Nome da pasta' }}</h5>
         <p class="pasta-ano">
            <i class="far fa-calendar color-theme mr-1"></i>
            {{ pasta.anoReferencia || 'Ano' }}
         </p>
      </div>
      <div class="pasta-actions" @click.stop="apagarPasta">
         <i class="fas fa-trash"></i>
      </div>
   </div>
</template>

<script>

import Swal from 'sweetalert2'
import { mapState, mapMutations } from 'vuex'

export default {
   name: 'Pasta',
   props: ['pasta', 'index'],
   computed: {
      ... mapState({
         dadosUsuario: state => state.dadosUsuario,
         tokenSessao: state => state.tokenSessao,
         urlRest: state => state.urlRest
      })
   },
   methods: {
      ... mapMutations([
         'deslogar'
      ]),
      abrirPasta : function () {
         this.$emit('abrirPasta', this.pasta.id);
      },
      apagarPasta : function () {
         Swal.fire({
            icon: 'warning',
            title: 'Excluir pasta',
            text: `Tem certeza que deseja excluir a pasta "${this.pasta.nome}"?`,
            confirmButtonText: 'Confirmar',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#dc3545',
            cancelButtonColor: '#6c757d'
         }).then((result) => {
            if (result.isConfirmed) {
               this.$emit('deletePasta', this.pasta.id);
            }
         });
      },
      formatarData : function (data) {
         if (!data) return '';
         const dataObj = new Date(data);
         return dataObj.toLocaleDateString('pt-BR');
      }
   }
}

</script>

<style scoped>
.pasta-card {
   background: var(--card-color);
   /* border: 1px solid #e0e0e0; */
   border: 1px solid rgba(0,0,0,.125);
   border-radius: .2rem;
   padding: 20px;
   cursor: pointer;
   transition: all 0.3s ease;
   position: relative;
   min-height: 140px;
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
   text-align: center;
   /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */
   box-shadow: 0 .1rem .3rem rgba(0,0,0,.14901960784313725);
}

.pasta-card:hover {
   /* transform: translateY(-4px); */
   box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
   border-color: var(--primary-color);
}

.pasta-icon {
   font-size: 60px;
   color: var(--primary-color);
   margin-bottom: 15px;
   transition: all 0.3s ease;
}

.pasta-card:hover .pasta-icon {
   transform: scale(1.1);
   color: var(--primary-color);
}

.pasta-content {
   flex: 1;
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
}

.pasta-nome {
   font-size: 18px;
   font-weight: 600;
   color: var(--text-color, #333);
   margin: 0 0 8px 0;
   line-height: 1.3;
   word-break: break-word;
}

.pasta-ano {
   font-size: 14px;
   color: var(--text-muted, #666);
   margin: 0;
   display: flex;
   align-items: center;
   justify-content: center;
}

.pasta-ano i {
   font-size: 12px;
}

.pasta-actions {
   position: absolute;
   top: 12px;
   right: 12px;
   width: 32px;
   height: 32px;
   display: flex;
   align-items: center;
   justify-content: center;
   border-radius: 50%;
   background: rgba(0, 0, 0, 0.05);
   color: var(--text-muted, #666);
   font-size: 14px;
   opacity: 0;
   transition: all 0.3s ease;
   cursor: pointer;
}

.pasta-card:hover .pasta-actions {
   opacity: 1;
}

.pasta-actions:hover {
   background: rgba(220, 53, 69, 0.1);
   color: #dc3545;
   transform: scale(1.1);
}

/* Responsividade */
@media (max-width: 768px) {
   .pasta-card {
      min-height: 120px;
      padding: 15px;
   }
   
   .pasta-icon {
      font-size: 40px;
      margin-bottom: 10px;
   }
   
   .pasta-nome {
      font-size: 16px;
   }
   
   .pasta-ano {
      font-size: 13px;
   }
}

/* Tema escuro */
[data-theme="dark"] .pasta-card {
   border-color: #444;
   background: var(--card-color);
}

[data-theme="dark"] .pasta-card:hover {
   border-color: var(--primary-color, #007bff);
}

[data-theme="dark"] .pasta-nome {
   color: var(--text-color, #fff);
}

[data-theme="dark"] .pasta-ano {
   color: var(--text-muted, #aaa);
}

[data-theme="dark"] .pasta-actions {
   background: rgba(255, 255, 255, 0.1);
   color: var(--text-muted, #aaa);
}

[data-theme="dark"] .pasta-actions:hover {
   background: rgba(220, 53, 69, 0.2);
   color: #dc3545;
}
</style>
